import { createSlice } from "@reduxjs/toolkit";

const initialLeaderboardSliceState =
{
    leaderboard: {}
};

const leaderboardSlice = createSlice({
    name: "leaderboard",
    initialState: initialLeaderboardSliceState,
    reducers: {
        setLeaderboard(state, action) {
            state.leaderboard = action.payload;
        }
    },
});

export default leaderboardSlice;